import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '../../route/auth/auth.service';

@Component({
    selector: 'ldw-log-out',
    templateUrl: './log-out.component.html',
    styleUrls: ['./log-out.component.css'],
    standalone: false
})
export class LogOutComponent implements OnInit {
  private authService = inject(AuthService);

  ngOnInit() {
    console.log('... logging out ...');
    this.authService.logout();
  }
}
